import { default as _91item_id_9373mve4zXcmMeta } from "/usr/src/app/web/pages/[id]/[item_id].vue?macro=true";
import { default as about_45usvxyExUnGfbMeta } from "/usr/src/app/web/pages/about-us.vue?macro=true";
import { default as company_45detailsKE20rNg141Meta } from "/usr/src/app/web/pages/company-details.vue?macro=true";
import { default as autobfBsAfZLdEMeta } from "/usr/src/app/web/pages/create/auto.vue?macro=true";
import { default as businessl9ZSK5WxXzMeta } from "/usr/src/app/web/pages/create/business.vue?macro=true";
import { default as buy_45sellZp95z3yboNMeta } from "/usr/src/app/web/pages/create/buy-sell.vue?macro=true";
import { default as educationTIHx13Bhn3Meta } from "/usr/src/app/web/pages/create/education.vue?macro=true";
import { default as estate4Q8jz4FmueMeta } from "/usr/src/app/web/pages/create/estate.vue?macro=true";
import { default as foodRglqMbRjZPMeta } from "/usr/src/app/web/pages/create/food.vue?macro=true";
import { default as servicesAJc7tv88jpMeta } from "/usr/src/app/web/pages/create/services.vue?macro=true";
import { default as truckObrOt9SnTDMeta } from "/usr/src/app/web/pages/create/truck.vue?macro=true";
import { default as upcoming_45eventsjVvsPkjvjCMeta } from "/usr/src/app/web/pages/create/upcoming-events.vue?macro=true";
import { default as worknr6CeXoqqvMeta } from "/usr/src/app/web/pages/create/work.vue?macro=true";
import { default as _91id_93GUu8lUfzsfMeta } from "/usr/src/app/web/pages/customer-ads/[id].vue?macro=true";
import { default as faqchfBPnmylbMeta } from "/usr/src/app/web/pages/faq.vue?macro=true";
import { default as FavoritesTHR2MiNIwQMeta } from "/usr/src/app/web/pages/Favorites.vue?macro=true";
import { default as for_45businesspMfHEGniPmMeta } from "/usr/src/app/web/pages/for-business.vue?macro=true";
import { default as help_45feedbacki4HeONh6GPMeta } from "/usr/src/app/web/pages/help-feedback.vue?macro=true";
import { default as indexAtQk1NbXKaMeta } from "/usr/src/app/web/pages/index.vue?macro=true";
import { default as paid_45serviceskI86ygKv5gMeta } from "/usr/src/app/web/pages/paid-services.vue?macro=true";
import { default as privacy_45policyctfeTsONY4Meta } from "/usr/src/app/web/pages/privacy-policy.vue?macro=true";
import { default as _91id_93puX1OCp3mKMeta } from "/usr/src/app/web/pages/product/[id].vue?macro=true";
import { default as productskxqIbgwTiKMeta } from "/usr/src/app/web/pages/products.vue?macro=true";
import { default as profileuO8p9NQhSpMeta } from "/usr/src/app/web/pages/profile.vue?macro=true";
import { default as reset_45passwordnwwrC9JxgNMeta } from "/usr/src/app/web/pages/reset-password.vue?macro=true";
import { default as _91q_93Y6eucvZd2dMeta } from "/usr/src/app/web/pages/search/[q].vue?macro=true";
import { default as terms_45of_45useAXSnwt4hZ0Meta } from "/usr/src/app/web/pages/terms-of-use.vue?macro=true";
export default [
  {
    name: "id-item_id",
    path: "/:id()/:item_id()",
    component: () => import("/usr/src/app/web/pages/[id]/[item_id].vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/usr/src/app/web/pages/about-us.vue")
  },
  {
    name: "company-details",
    path: "/company-details",
    component: () => import("/usr/src/app/web/pages/company-details.vue")
  },
  {
    name: "create-auto",
    path: "/create/auto",
    component: () => import("/usr/src/app/web/pages/create/auto.vue")
  },
  {
    name: "create-business",
    path: "/create/business",
    component: () => import("/usr/src/app/web/pages/create/business.vue")
  },
  {
    name: "create-buy-sell",
    path: "/create/buy-sell",
    component: () => import("/usr/src/app/web/pages/create/buy-sell.vue")
  },
  {
    name: "create-education",
    path: "/create/education",
    component: () => import("/usr/src/app/web/pages/create/education.vue")
  },
  {
    name: "create-estate",
    path: "/create/estate",
    component: () => import("/usr/src/app/web/pages/create/estate.vue")
  },
  {
    name: "create-food",
    path: "/create/food",
    component: () => import("/usr/src/app/web/pages/create/food.vue")
  },
  {
    name: "create-services",
    path: "/create/services",
    component: () => import("/usr/src/app/web/pages/create/services.vue")
  },
  {
    name: "create-truck",
    path: "/create/truck",
    component: () => import("/usr/src/app/web/pages/create/truck.vue")
  },
  {
    name: "create-upcoming-events",
    path: "/create/upcoming-events",
    component: () => import("/usr/src/app/web/pages/create/upcoming-events.vue")
  },
  {
    name: "create-work",
    path: "/create/work",
    component: () => import("/usr/src/app/web/pages/create/work.vue")
  },
  {
    name: "customer-ads-id",
    path: "/customer-ads/:id()",
    component: () => import("/usr/src/app/web/pages/customer-ads/[id].vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/usr/src/app/web/pages/faq.vue")
  },
  {
    name: "Favorites",
    path: "/Favorites",
    component: () => import("/usr/src/app/web/pages/Favorites.vue")
  },
  {
    name: "for-business",
    path: "/for-business",
    component: () => import("/usr/src/app/web/pages/for-business.vue")
  },
  {
    name: "help-feedback",
    path: "/help-feedback",
    component: () => import("/usr/src/app/web/pages/help-feedback.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/web/pages/index.vue")
  },
  {
    name: "paid-services",
    path: "/paid-services",
    component: () => import("/usr/src/app/web/pages/paid-services.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/usr/src/app/web/pages/privacy-policy.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("/usr/src/app/web/pages/product/[id].vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/usr/src/app/web/pages/products.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/usr/src/app/web/pages/profile.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/usr/src/app/web/pages/reset-password.vue")
  },
  {
    name: "search-q",
    path: "/search/:q()",
    component: () => import("/usr/src/app/web/pages/search/[q].vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/usr/src/app/web/pages/terms-of-use.vue")
  }
]